import {AddressInformation, PatientDemographics} from '@shared-library';

export function formatPatientDemographicsName(demographics?: PatientDemographics | null): string {
  if (!demographics?.patientName?.length) {
    return 'Not available';
  }

  const patientName = demographics.patientName[0];
  const givenNames = (patientName?.given || [])
    .map((name) => name?.trim())
    .filter((name): name is string => !!name)
    .join(' ');
  const familyName = (patientName?.family || '').trim();
  const suffix = patientName?.suffix ? String(patientName.suffix).trim() : '';

  const parts = [givenNames, familyName, suffix].filter((part) => !!part);
  return parts.length ? parts.join(' ') : 'Not available';
}

export function formatPatientDemographicsAddress(address?: AddressInformation | null): string {
  if (!address) {
    return 'Not available';
  }
  const streetLine = [address.street, address.unit]
    .map((value) => toCleanString(value))
    .filter((value) => !!value)
    .join(' ');
  const cityState = [
    toCleanString(address.city),
    toCleanString(address.state),
  ]
    .filter((value) => !!value)
    .join(', ');
  const zip = toCleanString(address.zip);
  const country = toCleanString(address.country);
  const county = toCleanString(address.county);

  const lines = [
    streetLine,
    [cityState, zip].filter((value) => !!value).join(' '),
    [country, county ? `${county} County` : ''].filter((value) => !!value).join(', '),
  ].filter((line) => !!line);

  return lines.length ? lines.join('\n') : 'Not available';
}

export function formatPatientDemographicsBirthdate(demographics?: PatientDemographics | null): string {
  if (demographics?.birthDate) {
    return String(demographics.birthDate).trim().split('T')[0];
  }

  return 'Not available';
}

function toCleanString(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).trim();
}
